import { useEffect, useMemo, useState } from 'react';
import enviro from 'enviro';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
const AUTHORIZE_URL_RE = /^(?!.*\s)[^?]*oauthor\/[^?]*\/authorize-url[^?]*(?:\?.*)?$/;
/**
 * Returns the URL for popup window
 * Case 1. Param `url` has a URL for request of authorize URL in OAuthor
 *   -> request of authorize URL -> return fetched URL in `popupUrl` field
 * Case 2. Param `url` has a URL for popup opening
 *   -> just return given url in `popupUrl` field
 */
export const usePopupUrl = ({
  url,
  skip
}) => {
  const [popupUrl, setPopupUrl] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const shouldSetPopupUrl = !(loading || error || popupUrl);
  useEffect(() => {
    if (url && !skip && shouldSetPopupUrl) {
      if (AUTHORIZE_URL_RE.test(url)) {
        setLoading(true);
        void http.get(url).then(resp => {
          const fetchedUrl = resp === null || resp === void 0 ? void 0 : resp.authorizeUrl;
          if (!fetchedUrl) {
            throw new Error(`Unable to fetch authorize URL using: ${url}`);
          }
          setPopupUrl(fetchedUrl);
        }).catch(err => {
          if (enviro.isQa()) {
            console.error('Unable to fetch authorize URL', {
              url
            });
          }
          Raven.captureException(err);
          setError(err);
        }).finally(() => {
          setLoading(false);
        });
      } else {
        setPopupUrl(url);
      }
    }
  }, [url, skip, shouldSetPopupUrl]);
  return useMemo(() => ({
    popupUrl,
    loading,
    error
  }), [error, loading, popupUrl]);
};